import { Link } from 'react-router-dom';
import './SolutionsBrands.css';
import logoAlpha   from '../../assets/brand_alphaess.svg';
import logoSofar   from '../../assets/brand_sofar.svg';
import logoGrowatt from '../../assets/brand_growatt.png';
import logoSolax   from '../../assets/brand_solax.png';
import logoSungrow from '../../assets/brand_sungrow.svg';
import logoRisen  from '../../assets/brand_risen_logo.png';

const brands = [
  { name: 'Growatt',      img: logoGrowatt, url: 'https://au.growatt.com/' },
  { name: 'Alpha ESS',    img: logoAlpha,   url: 'https://www.alphaess.com/' },
  { name: 'SOFAR Solar',  img: logoSofar,   url: 'https://www.sofarsolar.com/solution/residentialstorage.html' },
  { name: 'SolaX Power',  img: logoSolax,   url: 'https://www.solaxpower.com/' },
  { name: 'Sungrow',      img: logoSungrow, url: 'https://www.sungrowpower.com/au/en' },
  { name: 'RISEN ENERGY', img: logoRisen,   url: 'https://risenenergy.com.au/' },
];

const badges = [
  {
    label: 'Trusted\nBrands',
    icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none"><path d="M12 2L3 7v5c0 5.25 3.75 10.15 9 11.35C17.25 22.15 21 17.25 21 12V7l-9-5z" stroke="#666" strokeWidth="1.7" strokeLinejoin="round"/><path d="M9 12l2 2 4-4" stroke="#666" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  },
  {
    label: '10+ Years\nin Australia',
    icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="9" r="5" stroke="#666" strokeWidth="1.7"/><path d="M7.5 14.5l-4 7h17l-4-7" stroke="#666" strokeWidth="1.7" strokeLinejoin="round"/><circle cx="12" cy="9" r="2" stroke="#666" strokeWidth="1.7"/></svg>,
  },
  {
    label: 'Local Support\n& Warranty',
    icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none"><path d="M22 16.92v3a2 2 0 01-2.18 2A19.79 19.79 0 013.1 4.18 2 2 0 015.09 2h3a2 2 0 012 1.72c.13.96.36 1.9.71 2.81a2 2 0 01-.45 2.11L9.09 9.91a16 16 0 006.99 7l1.27-1.27a2 2 0 012.11-.45c.91.35 1.85.58 2.81.71A2 2 0 0122 16.92z" stroke="#666" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  },
  {
    label: 'Proven\nPerformance',
    icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17" stroke="#666" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/><polyline points="16 7 22 7 22 13" stroke="#666" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  },
];

export default function SolutionsBrands() {
  return (
    <section className="sb-section">
      <div className="sb-inner">
        <div className="sb-card">

          {/* Left dark panel */}
          <div className="sb-left">
            <h2 className="sb-heading">
              We Built Around Brands Australia{' '}
              <span className="sb-accent">Already Trusts</span>
            </h2>
            <div className="sb-divider" />
            <p className="sb-body">
              We only work with solar and battery brands that have been established in Australia for over 10 years — selected for reliability, long-term support, and real-world performance.
            </p>
            <Link to="/contact" className="sb-link">Compare Brands →</Link>
            <div className="sb-stars">
              <div className="sb-stars-row">{'★★★★★'.split('').map((s,i)=><span key={i}>{s}</span>)}</div>
              <p>10+ Years Trusted Brands</p>
            </div>
          </div>

          {/* Right panel */}
          <div className="sb-right">
            <div className="sb-logo-grid">
              {brands.map((b, i) => (
                <a key={i} href={b.url} target="_blank" rel="noopener noreferrer" className="sb-logo-btn">
                  {b.img
                    ? <img src={b.img} alt={b.name} className="sb-logo-img" />
                    : <span className="sb-logo-text">{b.name}</span>
                  }
                </a>
              ))}
            </div>

            <div className="sb-badges">
              {badges.map((b, i) => (
                <div key={i} className="sb-badge">
                  {b.icon}
                  <span>{b.label}</span>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
